"use client";

import { useAuth } from "../providers/auth-provider";
import { paths } from "../../../src/utils/paths";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { Button } from "@src/components/ui/button";
import Link from "next/link";
interface AuthenticatedEntryProps {
  redirectIfAuthenticated?: boolean;
}
export const AuthenticatedEntry: React.FunctionComponent<AuthenticatedEntryProps> = ({
  redirectIfAuthenticated = true
}) => {
  const {
    user,
    loading
  } = useAuth();
  const router = useRouter();
  useEffect(() => {
    if (redirectIfAuthenticated && user && !loading) {
      router.push(paths.home);
    }
  }, [redirectIfAuthenticated, user, loading, router]);
  if (loading) {
    return <div className="w-24">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground"></div>
      </div>;
  }
  if (user) {
    return null;
  }
  return <div className="flex gap-2" data-sentry-component="AuthenticatedEntry" data-sentry-source-file="authenticated-entry.tsx">
      <Link href={paths.signIn()} data-sentry-element="Link" data-sentry-source-file="authenticated-entry.tsx">
        <Button variant="outline" className="bg-card cursor-pointer" data-ph-capture-attribute-action="landing-sign-in" data-sentry-element="Button" data-sentry-source-file="authenticated-entry.tsx">
          Sign in
        </Button>
      </Link>
      <Link href={paths.register} data-sentry-element="Link" data-sentry-source-file="authenticated-entry.tsx">
        <Button className="bg-brand text-brand-foreground hover:bg-brand/90 cursor-pointer" data-ph-capture-attribute-action="landing-register" data-sentry-element="Button" data-sentry-source-file="authenticated-entry.tsx">
          Register
        </Button>
      </Link>
    </div>;
};